import { useQuery } from "@tanstack/react-query";
import { getLoyaltyPointsHistory } from "../admin/loyalty/loyaltyApi";

const loyaltyPointsKey = "loyalty-points-history";

export const useLoyaltyPointsHistory = (enabled: boolean) => {
  const { data, isLoading } = useQuery({
    queryKey: [loyaltyPointsKey],
    queryFn: ({ signal }) => getLoyaltyPointsHistory(signal),
    staleTime: 0,
    enabled,
  });

  return {
    loyaltyPointsHistory: data ?? [],
    isLoading,
  };
};
